import { Routes } from '@angular/router';
import { xpoAuthCanMatch } from '@xpo-ltl/ngx-auth';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'coordinators' },
  {
    path: 'coordinators',
    title: 'JMeter Runner',
    loadComponent: () => import('./features/jmeter/jmeter-shell.component').then((m) => m.JmeterShellComponent),
    canMatch: [xpoAuthCanMatch()],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'artemis',
      },
      {
        path: ':component',
        loadComponent: () =>
          import('./features/jmeter/component-page/component-page.component').then((m) => m.ComponentPageComponent),
      },
      {
        path: ':component/results/:result',
        title: 'JMeter Report',
        loadComponent: () =>
          import('./features/jmeter/report-page/report-page.component').then((m) => m.ReportPageComponent),
      },
    ],
  },
];
